export const ACCESS_TOKEN_KEY = 'access-token';
export const ROLE = 'role';
export const PROFILE_NAME = 'profileName';
export const COMPANY_ID = 'companyId';
export const IS_REDIRECT_TO_CHANGE_PASSWORD = 'isRedirectToChangePassword';
export const IS_EXPIRED_RENEWAL = 'isExpiredRenewal';
export const LICENCE_EXPIRY_AT = 'licence_expiry_at';
export const HAS_COMPANY_LICENCE_RENEWAL_ORDER =
  'has_company_licence_renewal_order';
export const ROLE_SYSTEM_SUPER_ADMIN = 1;
export const ROLE_SYSTEM_ADMIN = 2;
export const ROLE_COMPANY_SUPER_ADMIN = 3;
export const ROLE_COMPANY_ADMIN = 4;
export const ROLE_COMPANY_STAFF = 5;
// Chain type
export const FFB_AGGREGATOR = 1;
export const TRADER_OF_PALM_FFB = 2;
export const ARTISANAL_MILLS = 3;
export const INDUSTRIAL_MILLS = 4;
export const REFINERY = 5;
export const MANUFACTURER = 6;
export const IMPORTER = 7;
export const SERVICE_PROVIDER = 8;
export const TRADER_OF_CRUDE_PALM_OIL = 9;
export const EXPORTER_OF_CRUDE_PALM_OIL = 10;
export const NURSERY_OPERATORS = 11;
export const INPUT_DEALER = 12;
// GENDER
export const MALE = 1;
export const FEMALE = 2;
// Status company registration
export const NOT_PAY = 0;
export const WAITING = 1;
export const APPROVED = 2;
export const DENIED = 3;
export const DELETED = 4;
//Type of file
export const VIDEO = 14;
//Timeout
export const REQUEST_TIMEOUT = 120000; //2 minutes
// Payment method
export const MOMO = 1;
export const BANKING = 2;
// Payment fee
export const REGISTRATION_FEE = 1;
export const ALL_FEE = 2;
//Product sticker status
export const PRODUCT_STICKER_WAITING = 1;
export const PRODUCT_STICKER_APPROVED = 2;
export const PRODUCT_STICKER_DENIED = 3;
export const PRODUCT_STICKER_DELETED = 4;
